import { useEffect, useState } from "react";
import CryptoES from "crypto-es";
import HomeView from "./view";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ReducersTypes } from "@/redux/reducers/Models";
import { setCustomer } from "@/redux/ducks/customer";
import { getFormattedValue } from "@/utils/functions";
import { useDebts } from "@/hooks/useDebts";
import { usePaidItems } from "@/hooks/usePaidItems";
import { useSingleFlag } from "@/hooks/useFlags";
import { needsAddressForPayment } from "@/utils/customerAddress";

export default function Home() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    isEnabled: isAutoPaymentEnabled,
    isLoading: isLoadingAutoPaymentFlag,
  } = useSingleFlag("PD_COBRANCA_DIRETA");
  const {
    isEnabled: isNotificationsEnabled,
    isLoading: isLoadingNotificationsFlag,
  } = useSingleFlag("PD_NOTIFICACOES");
  const customer = useSelector((state: ReducersTypes) => state.customerReducer);

  const [isShowingMenu, setIsShowingMenu] = useState(false);
  const [isVisibleRecharge, setIsVisibleRecharge] = useState(false);
  const [isVisibleCardModal, setIsVisibleCardModal] = useState(true);
  const [activeTab, setActiveTab] = useState<"todas" | "pendentes" | "pagos">(
    "pendentes",
  );

  const {
    isLoading: isLoadingDebts,
    debts,
    cart,
    onChange,
    getDebts,
  } = useDebts();
  const {
    isLoading: isLoadingPaidItems,
    items: paidItems,
    refetch: refetchPaidItems,
  } = usePaidItems();

  const toggleMenu = () => setIsShowingMenu((isShowingMenu) => !isShowingMenu);

  const goToVehicles = (plates: string | string[]) => {
    dispatch(
      setCustomer({
        selectedVehicles: Array.isArray(plates) ? plates : [plates],
      }),
    );
    navigate("/myvehicles");
  };

  const goToWallet = () => navigate("/wallet");

  const goToRecharge = () => {
    if (needsAddressForPayment(customer)) {
      navigate("/payment/address");
      return;
    }
    navigate("/payment");
  };

  const goToNewCard = () => navigate("/newcard");

  const goToBuy = () => navigate("/buy");

  const goToNotifications = () => navigate("/notifications");

  const showRecharge = async () => {
    const clientId = CryptoES.SHA512(customer?.client?.id!);
    const showWelcome = localStorage.getItem("showWelcome" + clientId);
    if (
      !showWelcome &&
      customer?.account?.balance === 0 &&
      !customer?.account?.card?.cardNumber
    ) {
      localStorage.setItem("showWelcome" + clientId, "true");
      setIsVisibleRecharge(true);
    }
  };

  const handleTabChange = (tab: "todas" | "pendentes" | "pagos") => {
    setActiveTab(tab);
    if (tab === "todas") {
      if (!isLoadingDebts) getDebts();
      if (!isLoadingPaidItems) refetchPaidItems();
    } else if (tab === "pagos") {
      if (!isLoadingPaidItems) refetchPaidItems();
    } else {
      if (!isLoadingDebts) getDebts();
    }
  };

  const handleDisablePendingAttemptPayment = () => {
    dispatch(
      setCustomer({
        disablePendingAttemptPaymentModal: true,
      }),
    );
  };

  useEffect(() => {
    showRecharge();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customer?.account]);

  const isLoadingFlags = isLoadingAutoPaymentFlag || isLoadingNotificationsFlag;

  return (
    <>
      <HomeView
        goToVehicles={goToVehicles}
        items={paidItems || []}
        isLoading={isLoadingDebts || isLoadingPaidItems}
        isShowingMenu={isShowingMenu}
        toggleMenu={toggleMenu}
        goToWallet={goToWallet}
        balance={getFormattedValue(customer?.account?.balance ?? 0)}
        plate={
          customer?.selectedVehicles?.length
            ? customer.selectedVehicles
            : (customer?.vehicles?.[0]?.plate ?? "")
        }
        vehicles={customer?.vehicles}
        hasVehicles={customer?.vehicles!?.length > 1}
        isVisibleRecharge={
          isVisibleRecharge &&
          !customer?.isLoading &&
          !isLoadingFlags &&
          !isLoadingDebts
        }
        goToRecharge={() => {
          setIsVisibleRecharge(false);
          goToRecharge();
        }}
        hasPendingAttemptPayment={
          !customer?.disablePendingAttemptPaymentModal &&
          debts?.some((debt) => debt.flRetentativa === 1)
        }
        handleDisablePendingAttemptPayment={handleDisablePendingAttemptPayment}
        setIsVisibleRecharge={setIsVisibleRecharge}
        goToBuy={goToBuy}
        isVisibleCardModal={isVisibleCardModal}
        setIsVisibleCardModal={setIsVisibleCardModal}
        debts={debts}
        cart={cart}
        onChangeDebts={onChange}
        activeTab={activeTab}
        onTabChange={handleTabChange}
        goToNewCard={goToNewCard}
        isAutoPaymentEnabled={isAutoPaymentEnabled}
        goToNotifications={goToNotifications}
        isNotificationsEnabled={isNotificationsEnabled}
      />
    </>
  );
}
